var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tab-heading" },
    [
      _c(
        "b-row",
        { staticClass: "border-bottom pb-3 mt-2 mt-md-0" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6", lg: "auto", order: "2", "order-lg": "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-2 mt-lg-0",
                  attrs: {
                    size: "lg",
                    variant: _vm.isPrevDisabled ? "secondary" : "success",
                    disabled: _vm.isPrevDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("prev-tab")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("navigate_before"),
                  ]),
                  _vm._v("Prev"),
                ]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "", order: "1", "order-lg": "2" } },
            [_vm._t("default")],
            2
          ),
          _c(
            "b-col",
            {
              staticClass: "text-right",
              attrs: { cols: "6", lg: "auto", order: "3", "order-lg": "3" },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-2 mt-lg-0",
                  attrs: {
                    size: "lg",
                    variant: _vm.isNextDisabled ? "secondary" : "success",
                    disabled: _vm.isNextDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("next-tab")
                    },
                  },
                },
                [
                  _vm._v("Next"),
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("navigate_next"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }